import moment from 'moment'

export const dateMixins = {
  methods: {
    formatDate(date) {
      if (this.checkValidDate(date, 'MM-DD-YYYY')) {
        return moment(date).format('MM-DD-YYYY')
      }

      return null
    },

    formatDateTime(date) {
      if (this.checkValidDate(date, 'MM-DD-YYYY hh:mm:ss A')) {
        return moment(date).format('MM-DD-YYYY hh:mm:ss A')
      }

      return null
    },

    covertDateTimeToTime(datetime) {
      if (this.checkValidDate(datetime, 'hh:mm:ss A')) {
        return moment(datetime).format('hh:mm:ss A')
      }

      return null
    },

    checkValidDate(date, format) {
      const isValid = moment(date).format(format)

      if (isValid === 'Invalid date') {
        return null
      }

      return true
    },

    checkValidDateDigits(str, max) {
      if (str.charAt(0) !== '0' || str === '00') {
        let num = parseInt(str)
        if (isNaN(num) || num <= 0 || num > max) num = 1
        str = num > parseInt(max.toString().charAt(0)) && num.toString().length === 1 ? `0 ${num}` : num.toString()
      }
      return str
    },

    handleAutoDateFormat() {
      this.type = 'text'
      let input = this.value
      // eslint-disable-next-line no-useless-escape
      if (/\-$/.test(input)) input = input.substr(0, input.length - 2)
      const values = input.split('-').map(function(v) {
        return v.replace(/\D/g, '')
      })
      // eslint-disable-next-line no-undef
      if (values[0]) values[0] = checkValidDateDigits(values[0], 12)
      // eslint-disable-next-line no-undef
      if (values[1]) values[1] = checkValidDateDigits(values[1], 31)
      const output = values.map(function(v, i) {
        return v.length === 2 && i < 2 ? `${v}-` : v
      })
      this.value = output.join('').substr(0, 14)
    },

    formatDateByTimeZoneOffSet(date, format, offset) {
      if (this.checkValidDate(date, format)) {
        return moment(date)
          .utcOffset(offset)
          .format(format)
      }

      return null
    }
  }
}
